import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Clock, XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function TiendaGracias() {
  const [sp] = useSearchParams();
  const folio = sp.get("folio") || "";
  const r = sp.get("r") || "ok";

  const cfg = {
    ok: { icon: CheckCircle2, color: "text-emerald-500", titulo: "¡Gracias por tu compra!",
      msg: `Tu pedido ${folio} fue confirmado. Te enviamos el comprobante a tu correo y te avisaremos cuando salga el despacho.` },
    pendiente: { icon: Clock, color: "text-amber-500", titulo: "Pago en proceso",
      msg: `Tu pedido ${folio} quedó registrado. Apenas se confirme el pago te llegará el comprobante por correo.` },
    error: { icon: XCircle, color: "text-red-500", titulo: "El pago no se completó",
      msg: `Tu pedido ${folio} quedó guardado pero el pago no se concretó. Puedes intentarlo de nuevo o escribirnos por WhatsApp.` },
  }[r] || {};
  const Icon = cfg.icon || CheckCircle2;

  return (
    <div className="bg-[#F8FAFC] min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <Icon className={`h-16 w-16 mx-auto mb-4 ${cfg.color}`} />
        <h1 className="font-heading text-3xl font-bold text-[#111827]">{cfg.titulo}</h1>
        <p className="text-gray-500 mt-3">{cfg.msg}</p>
        <div className="mt-7 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/productos"><Button className="bg-[#384091] text-white h-12 px-6">Volver a la tienda</Button></Link>
          <a href={`https://wa.me/56929894282?text=${encodeURIComponent(`Hola, consulto por mi pedido ${folio}`)}`}
            target="_blank" rel="noopener noreferrer">
            <Button variant="outline" className="h-12 px-6">Consultar por WhatsApp</Button>
          </a>
        </div>
      </div>
    </div>
  );
}
